import { Permisos_recepciones } from './../../../models/permisos_recepciones.model';
import { Component, ViewChild, ElementRef, TemplateRef } from "@angular/core";
import * as moment from 'moment'
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material';
declare var jQuery: any;
declare var $: any;
@Component({
    selector: "page-permisos_recepciones",
    templateUrl: "./permisos_recepciones.component.html",
    styleUrls: ["./permisos_recepciones.component.css"],
    providers: [FormService]
})

export class Permisos_recepcionesComponent {
    @ViewChild('openModal') openModal: TemplateRef<any>;
    @ViewChild('openModalNODATA') openModalNODATA: TemplateRef<any>;

    public rows = [];
    public actualRow;
    public permisos_recepciones: Permisos_recepciones;
    public form;
    public temp_perm;
    public matcher = new FormService();
    public maxDate;
    public selected;

    constructor(private fb: FormBuilder, private dialog: MatDialog) {
        this.maxDate = moment().toDate()

        this.form = new FormGroup({
            tipo_permiso: new FormControl(''),
            numero_permiso: new FormControl(''),
            fecha_permiso: new FormControl(''),

        })


        if (!JSON.parse(localStorage.getItem("permisos_recepciones"))) {
            localStorage.setItem("permisos_recepciones", JSON.stringify(this.rows));
        } else {
            this.rows = JSON.parse(localStorage.getItem("permisos_recepciones"));

        }
        this.permisos_recepciones = { tipo_permiso: '', numero_permiso: '', fecha_permiso: '' };
        this.temp_perm = { tipo_permiso: '', numero_permiso: '', fecha_permiso: '' };

    }

    add_permisos_recepciones() {

        this.actualRow = localStorage.getItem("permisos_recepciones");
        this.rows = JSON.parse(this.actualRow);

        /*     console.log(this.form.value); */

        if (!this.form.value.tipo_permiso || !this.form.value.numero_permiso || !this.form.value.fecha_permiso) {
            console.log("no se ingresaron datos");
            this.dialog.open(this.openModalNODATA);
        } else {
            this.rows = this.rows.concat({
                tipo_permiso: this.form.value.tipo_permiso,
                numero_permiso: this.form.value.numero_permiso,
                fecha_permiso: this.form.value.fecha_permiso ? moment(this.form.value.fecha_permiso).format('DD/MM/YYYY') : "", 

            })
            localStorage.setItem("permisos_recepciones", JSON.stringify(this.rows));
            this.form.reset();
        }
    }
    delete_permisos_recepciones(id) {
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("permisos_recepciones", JSON.stringify(this.rows));
            }
        }
    }

    onChangeSelect(event) {
        let value = event.target.value;
    }
    get_permisos_recepciones(id) {
        for (let x = 0; x < this.rows.length; x++) {

            if (id == x) {
                this.temp_perm.id = id;
                this.temp_perm.tipo_permiso = this.rows[x].tipo_permiso;
                this.temp_perm.numero_permiso = this.rows[x].numero_permiso;
                this.temp_perm.fecha_permiso = this.rows[x].fecha_permiso;

                this.dialog.open(this.openModal);

            }
        }
    }

    cleanData() {
        this.temp_perm = { tipo_permiso: '', numero_permiso: '', fecha_permiso: '' };

    }

    savepermisos_recepciones() {
        var id = this.temp_perm.id;
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("permisos_recepciones", JSON.stringify(this.rows));

                $("#antec_modal").modal("hide");
                this.actualRow = localStorage.getItem("permisos_recepciones");
                this.rows = JSON.parse(this.actualRow);
                this.rows = this.rows.concat({
                    tipo_permiso: this.temp_perm.tipo_permiso,
                    numero_permiso: this.temp_perm.numero_permiso,
                    fecha_permiso: this.temp_perm.fecha_permiso,

                })
                localStorage.setItem("permisos_recepciones", JSON.stringify(this.rows));
                //this.temp_perm.reset();
                this.dialog.closeAll();
            }
        }
    }

}